// extracted by mini-css-extract-plugin
var _1 = "t2Mb";
var _2 = "t2Ma";
var _3 = "t2L_";
var _4 = "t2L-";
export { _1 as "deviceName", _2 as "deviceType", _3 as "icon", _4 as "title" }
